import React from 'react';
import classnames from 'classnames/bind';
import logo from '../../assets/logo.png';
import styles from './Footer.module.scss';

const cx = classnames.bind(styles);

export default function Footer() {
    return (
        <footer className={cx('Footer')}>
            <div className={cx('Inner')}>
                <div className={cx('Brand')}>
                    <img src={logo} alt='Shadowpilot logo' className={cx('Logo')} />
                    <div>
                        <p className={cx('Name')}>Shadowpilot</p>
                        <p className={cx('Tagline')}>Your autonomous AI avatar for social media.</p>
                    </div>
                </div>
            </div>

            <div className={cx('Legal')}>
                © {new Date().getFullYear()} Shadowpilot. All rights reserved.
            </div>
        </footer>
    );
}
